<div class="topbar">
  <div>
    <h1>Indstillinger for områdesortliste</h1>
  </div>
  <div class="topbar__actions">
    @if (canEdit) {
      <button class="btn-icon green" (click)="add()" matTooltip="Opret nyt område">
        <mat-icon svgIcon="add"></mat-icon>
        <span>Opret nyt område</span>
      </button>
    }
  </div>
</div>
<div class="page__content settings">
  <div class="settings__wrap">
    <table mat-table [dataSource]="AreaBlacklist" class="mat-elevation-z0 settings__table">
      <ng-container matColumnDef="areaBlacklistZip">
        <th mat-header-cell *matHeaderCellDef>Postnummer</th>
        <td mat-cell *matCellDef="let row">
          {{ row.areaBlacklistZip }}
        </td>
      </ng-container>
      <ng-container matColumnDef="areaBlacklistPlaceName">
        <th mat-header-cell *matHeaderCellDef>Område</th>
        <td mat-cell *matCellDef="let row">
          {{ row.areaBlacklistPlaceName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell class="row-actions" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <div class="hidden-cell">
            @if (canEdit) {
              <button (click)="delete(row)" class="btn-icon blue" aria-label="Slet område" matTooltip="Slet område">
                <mat-icon svgIcon="delete"></mat-icon>
              </button>
            }
            <button (click)="showhistory(row)" class="btn-icon blue" aria-label="Historik" matTooltip="Historik">
              <mat-icon>timeline</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
<app-history-view [historyView]="historyView"></app-history-view>
